import LocalizedStrings from 'react-localization';

export const composeActionLabel = (action: string, ...items: string[]): string =>
  lang.formatString(action, ...items).toString();

const PAGE_FILTER_FIELDS_EN = {
  keyword: 'Keyword',
  merchants: 'Merchants',
  txId: 'Transaction ID',
  currency: 'Currency',
  minAmount: 'Min Amount',
  maxAmount: 'Max Amount',
  startDate: 'Start Date',
  endDate: 'End Date',
  lastUpdatedFrom: 'Last Updated From',
  lastUpdatedTo: 'Last Updated To',
  pspStatus: 'PSP Status Code',
  pspStatusMsg: 'PSP Status Message',
  type: 'Transaction Type',
  psp: 'PSPs',
  initialPsp: 'Initial PSPs',
  status: 'Status Description',
  user: 'User',
  userEmail: 'User Email',
  userStreet: 'Street',
  userCity: 'City',
  userZip: 'ZIP',
  userDOB: 'User DOB',
  userMobile: 'Mobile',
  userIp: 'User IP',
  userAccount: 'User Account',
  bankName: 'Bank Name',
  pspRefId: 'PSP Reference ID',
  originTx: 'Origin Transaction ID',
  userCountry: 'User Country',
  siteRefId: 'Site Reference ID',
  pspUserRef: 'PSP User Reference',
  paymentMethod: 'Payment Method',
  attribute: 'Attribute',
  info: 'Info',
  rangeStart: 'Range Start',
  rangeEnd: 'Range End',
  cardBrand: 'Card Brand',
  cardType: 'Card Type',
  countryCode: 'Country Code',
  cardSubBrand: 'Card subbrand',
  cardCategory: 'Card Category',
  source: 'Source',
  lastUpdated: 'Last Updated',
  created: 'Created',
  state: 'State',
  merchantId: 'Merchant ID',
};

const TRANSACTION_COLUMNS_EN = {
  merchantId: 'Merchant ID',
  id: 'Transaction ID',
  merchantUserId: 'User',
  merchantUserEmail: 'User Email',
  kycStatus: 'KYC Status',
  suspectedAbuseReason: 'Abuse',
  blockedAccountReason: 'Blocked',
  txType: 'Transaction Type',
  txAmount: 'Transaction Amount',
  txAmountBase: 'Base Transaction Amount',
  merchantUserBal: 'User Balance',
  created: 'Created',
  state: 'State',
  ipAddr: 'User IP',
  statusCode: 'Status Description',
  statusCodeInt: 'Status Code',
  pspStatusCode: 'PSP Status Code',
  pspStatusMsg: 'PSP Status Message',
  psp: 'PSP',
  pspAccount: 'PSP Account',
  initiatedPsp: 'Init PSP',
  initiatedPspAccount: 'Init PSP Account',
  pspService: 'PSP Service',
  paymentMethod: 'Payment Method',
  rules: 'Rules',
  amount: 'Amount',
  fee: 'Fee',
  amountBase: 'Base Amount',
  feeBase: 'Base Fee',
  pspFee: 'PSP Fee',
  pspFeeBase: 'Base PSP Fee',
  authAmount: 'Auth Amount',
  authAmountBase: 'Base Auth Amount',
  lastUpdated: 'Updated',
  channelId: 'Channel',
  depositType: 'Deposit Type',
  merchantUserCat: 'User Category',
  merchantUserCountry: 'User Country',
  maskedUserAccount: 'User Account',
  bankName: 'Bank Name',
  accountHolderName: 'Account Holder',
  updatedBy: 'Last Updated By',
  pspUserRef: 'PSP User Reference',
  pspFraudScore: 'PSP Fraud Score',
  pspRefId: 'PSP Reference ID',
  merchantTxId: 'Site Reference ID',
  bonusCode: 'Bonus Code',
  info: 'Info',
  lastInfo: 'Last Info',
  kycPspName: 'KYC PSP Name',
  kycPspStatus: 'KYC PSP Status',
  kycPspIdStatus: 'KYC ID Status',
  kycPspAddressStatus: 'KYC Address Status',
  kycPspLivenessStatus: 'KYC Liveness Status',
  kycPspAgeStatus: 'KYC Age Status',
  kycPspPepAndSanction: 'KYC PEP and Sanction',
  issuerCountry: 'Card Issuer Country',
  issuerInfoBrand: 'Card Brand',
  issuerInfoCategory: 'Card Category',
  issuerInfoName: 'Card Issuer Name',
  issuerInfoNumber: 'Card BIN',
  issuerInfoType: 'Card Type',
  firstAttempt: 'First Attempt',
  firstSuccessful: 'First Successful',
  firstTxTypeAttempt: 'First Transaction Type Attempt',
  firstTxTypeSuccessful: 'First Transaction Type Successful',
  firstUserPspAccountAttempt: 'First PSP Account Attempt',
  firstUserPspAccountSuccessful: 'First PSP Account Successful',
  firstName: 'First Name',
  lastName: 'Last Name',
  merchantUserStreet: 'Street',
  merchantUserCity: 'City',
  merchantUserZip: 'ZIP',
  merchantUserDOB: 'DOB',
  merchantUserMobile: 'Mobile',
  fraudProviderStatus: 'Fraud Status',
  ipCity: 'IP City',
  ipRegion: 'IP Region',
  ipCountry: 'IP Country',
  originTxId: 'Origin Transaction ID',
  txRefId: 'Transaction Reference ID',
};

const lang = new LocalizedStrings({
  en: {
    minimizeItem: 'Minimize {0}',
    clickToGoTo: 'Click to go to {0}',
    copy: 'Create a copy of this {0}',
    toggle: 'Toggle {0}',
    addItem: 'Add {0}',
    saveItem: 'Save {0}',
    updateItem: 'Update {0}',
    replaceItem: 'Replace {0}',
    createdItem: 'Created {0}',
    addedItem: 'Added {0}',
    newItem: 'New {0}',
    updatedItem: 'Updated {0}',
    deletedItem: 'Deleted {0}',
    removedItem: 'Removed {0}',
    showingItem: 'Showing {0}',
    displayItem: 'Display {0}',
    configureItem: 'Configure {0}',
    saved: 'Saved',
    undoItem: 'Undo {0}',
    back: 'Back',
    next: 'Next',
    resetItem: 'Reset {0}',
    cancelItem: 'Cancel {0}',
    deleteItem: 'Delete {0}',
    editItem: 'Edit {0}',
    viewItem: 'View {0}',
    failedTo: 'Failed to {0}',
    signOut: 'Sign out',
    showItem: 'Show {0} {1}',
    hideItem: 'Hide {0} {1}',
    exportItem: 'Export {0}',
    importItem: 'Import {0}',
    includeItem: 'Include {0}',
    noFound: 'No {0} found',
    enableItem: 'Enable {0}',
    disableItem: 'Disable {0}',
    enabledItem: 'Enabled {0}',
    disabledItem: 'Disabled {0}',
    xWasNotYError: '{0} could not be {1}.',
    xWasYSuccess: '{0} successfully {1}',
    xIsNotAvailable: '{0} is not available',
    changesOn: 'Changes on {0}',
    minOne: 'Please add at least one {0}',
    perItem: 'Per {0}',
    areYouSureX: 'Are you sure you want to {0}?',
    matchItem: 'Match {0}',
    isItem: 'Is {0}',
    products: {
      piq: 'PaymentIQ',
      cashier: 'Cashier',
      backoffice: 'Backoffice',
      aiq: 'AccountIQ',
      docs: 'Documentation',
    },
    syntax: {
      conj: {
        cuml: 'and',
      },
    },
    errors: {
      unspecified: 'Something went wrong. Please try again later.',
      formHasErrors: 'The form has errors',
    },
    generics: {
      reason: 'Reason',
      id: 'ID',
      success: 'Success',
      support: 'Support',
      create: 'Create',
      force: 'Force',
      override: 'Override',
      continue: 'Continue',
      created: 'Created',
      systemStatus: 'System Status',
      approve: 'Approve',
      approved: 'Approved',
      delete: 'Delete',
      actionCompleted: '{0} action successfully completed',
      deny: 'Deny',
      denied: 'Denied',
      cancel: 'Cancel',
      confirm: 'Confirm',
      comment: 'Comment',
      confirmItem: 'Confirm {0}',
      selectReason: 'Select reason',
      reasonToAction: 'Reason to {0}',
      lastDaysCount: 'Last {0} days',
      allPendingWithdrawals: 'All Pending Withdrawals',
      refresh: 'Refresh',
      remove: 'Remove',
      downloadReport: 'Download Report',
      noData: 'No data available',
      minimize: 'Minimize',
      never: 'Never',
      loginFailed: 'Login failed - please contact support. Failure code: {0}',
      total: 'Total',
      acceptanceRate: 'Acceptance Rate',
      generalHealth: 'General Health',
      fetchReport: 'Fetch Report',
      transactions: 'Transactions',
      transactionsOverview: 'Transactions Overview',
      transactionsWaitingApproval: 'Transactions Waiting for Approval',
      transactionsToApprove: 'Transactions to approve',
      successful: 'Successful',
      last24Hrs: 'Last 24h',
      neverLoggedIn: 'Never logged in',
      shouldResetPassword: 'User must change password at next logon',
      shouldResetPasswordHelpText: 'The user will be prompted to reset their password when they next log in.',
      setSecurityKey: 'Set up Security Key',
      setSecurityKeyHelpText: 'The user will be prompted to set up a security key when they next log in.',
      setAuth: 'Set up Authenticator Application',
      setAuthHelpText:
        'The user will be prompted to set up an authenticator application when they next log in.',
      twoFactorRequired: 'Two-Factor Authentication is required, please select one of the first two options',
      cannotBeChanged: 'cannot be changed',
      history: 'History',
      numberOfChanges: 'Number of changes',
      twoFCred: 'Two-Factor Credentials',
      requiredActions: 'Required actions',
      twoFA: 'Two-Factor Authentication (2FA)',
      security: 'Security',
      lastCredentialDeleted:
        'Last credential was deleted. The user will receive a request to configure the Authenticator application.',
      required: 'required',
      markPref: 'Mark as preferred',
      actionNotCompleted: 'The action could not be performed',
      changesSaved: 'Your changes have been saved',
      unsavedChanges: 'Unsaved changes',
      clear: 'Clear',
      pwdResetLinkSent: "Password reset link was sent to the user's email",
      pwdResetLinkError: 'Failed to send password reset link.',
      updated: 'updated',
      enabled: 'Enabled',
      disabled: 'Disabled',
      error: 'Error',
      merchants: 'Merchants',
      roles: 'Roles',
      role: 'role',
      phone: 'Phone',
      email: 'Email',
      name: 'Name',
      displayName: 'Display Name',
      product: 'Product',
      products: 'Products',
      verticals: 'Verticals',
      licenses: 'Licenses',
      operationTime: 'Operation Time',
      processingTime: 'Processing Time',
      transactionLimit: 'Transaction Limit',
      transactionFees: 'Transaction Fees',
      integrationDate: 'Integration Date',
      transactionTypes: 'Transaction Types',
      transactionType: 'Transaction Type',
      statusDescription: 'Status Description',
      pspStatusCode: 'PSP Status Code',
      userAccount: 'User Account',
      cardBrand: 'Card Brand',
      cardType: 'Card Type',
      cardIssuerCountry: 'Card Issuer Country',
      ipCountry: 'IP Country',
      ipAddress: 'IP Address',
      firstSuccessful: 'First Successful',
      ipRegion: 'IP Region',
      cardCategory: 'Card Category',
      username: 'Username',
      configuration: 'Configuration',
      provider: 'Provider',
      type: 'Type',
      template: 'Template',
      firstName: 'First Name',
      lastName: 'Last Name',
      invalid: 'invalid',
      adminApiRolesDoc: 'the Backoffice User Roles Documentation',
      resetPwd: 'Reset Password',
      lastLogin: 'Last login',
      user: 'User',
      users: 'Users',
      merchant: 'Merchant',
      merchantId: 'Merchant ID',
      mId: 'MID',
      parameter: 'Parameter',
      pm: 'Payment Method',
      pms: 'Payment Methods',
      bin: 'BIN',
      ip: 'IP',
      psp: 'PSP',
      psps: 'PSPs',
      premium: 'Premium',
      countries: 'Countries',
      currencies: 'Currencies',
      contact: 'Contact',
      x3ds2: '3DS2',
      fp: 'Fraud Provider',
      refreshOrContactSupport: ' Refresh the page and try again. If the problem persists, contact support.',
      noItemsFound: 'No items found',
      jobInformation: 'Job Information',
      personalInfo: 'Personal Information',
      jobTitle: 'Job Title',
      contactTypes: 'Contact Type(s)',
      primFin: 'Primary Financial Contact',
      secFin: 'Secondary Financial Contact',
      primCom: 'Commercial Contact',
      primOp: 'Primary Operational Contact',
      secOp: 'Secondary Operational Contact',
      primSup: 'Primary Support Contact',
      communication: 'Communication',
      releaseNotes: 'Release Notes',
      incidentNotes: 'Maintenance and Incident Notifications',
      marketingNewsletter: 'Marketing/Newsletter',
      entries: 'entries',
      all: 'All',
      page: 'Page',
      reset: 'Reset',
      continueChangesLost: 'Are you sure you want to continue? Any unsaved changes will be lost.',
      stayUpdated: 'Please update your information',
      leaveMerchantsEmpty:
        'Leave the Merchants field empty to allow access to all merchants within the hierarchy.',
      info: 'Additional information',
      infoLowerCased: 'info',
      preferences: 'preferences',
      backofficeHomepage: 'Select start page',
      sidebar: 'Sidebar',
      widget: 'Widget',
      aiChatbot: 'AI Chatbot',
      homepage: 'Homepage',
      view: 'View',
      waiting: 'Waiting',
      cancelled: 'Cancelled',
      failed: 'Failed',
      whatsNew: "What's New",
      load: 'Load',
      locale: 'Locale',
      default: 'Default',
      logo: 'Logo',
      deleted: 'Deleted',
      apply: 'Apply',
      translations: 'Translations',
      restoreLayout: 'Restore Widget layout',
      active: 'Active',
      rule: 'Rule',
      preconditions: 'Preconditions',
      details: 'Details',
      transactionId: 'Transaction ID',
      note: 'Note',
      shouldOverride: "Override existing id's",
      fileName: 'Select file',
      generate: 'Generate',
      field: 'Field',
      file: 'File',
      order: 'Order',
      changes: 'Changes',
      status: 'Status',
      conditions: 'Conditions',
      actions: 'Actions',
      not: 'Not',
      item: 'Item',
      items: 'Items',
      revert: 'Revert',
      value: 'Value',
      choose: 'Choose',
      ruleset: 'Ruleset',
      rulesets: 'Rulesets',
      imported: 'Imported',
      move: 'Hold and drag to move',
      transaction: 'Transaction',
      group: 'Group',
      pleaseSelectItem: 'Please select {0}',
      pleaseEnterItem: 'Please enter {0}',
      columns: 'Columns',
      customizeTable: 'Customize table',
      changePriority: 'Change priority',
      changePriorityApproval: 'Change priority approval',
      viewPendingChanges: 'View pending changes',
      clearFields: 'Clear fields',
      optional: 'Optional',
      saveAsItem: 'Save as {0}',
      userId: 'User ID',
      method: 'Method',
      balance: 'Balance',
      currency: 'Currency',
      kycStatus: 'KYC Status',
      channelId: 'Channel',
      mobile: 'Mobile',
      sex: 'Sex',
      street: 'Street',
      zip: 'Zip',
      state: 'State',
      city: 'City',
      country: 'Country',
      paymentMethod: 'Payment method',
      paymentMethodCC: 'Payment Method',
      amount: 'Amount',
      simulate: 'Simulate',
      transactionIds: 'Transaction IDs',
      applyTemplate: 'Apply template',
      response: 'Response',
      importModalInfo:
        'Choose a file from your device to upload, and add a note in order to import successfully.',
      leaveANoteHere: 'Leave a note here',
      selectOneOrMore: 'Select one or more',
      selectOne: 'Select one',
      noResultsFound: 'No results found',
      totalTransactions: 'Total Transactions',
      selectRuleset: 'Select ruleset',
      selectARuleset: 'Select a ruleset',
      compare: 'Compare',
      rulesetName: 'Ruleset name',
      noPreconditionsSet: 'No preconditions have been set yet.',
      global: 'Global',
      partiallyGlobal: 'Partially Global',
      currentPriorty: 'Current priority',
      newPriority: 'New priority',
      newPriorityToApprove: 'New priority to approve',
      changesOverride: 'Changes override',
      areYouSureNewRulesetLostChanges:
        'Are you sure you want to create a new ruleset? All unsaved changes will be lost.',
      yes: 'Yes',
      no: 'No',
      switchToMid: 'Switch to MID',
      openInEditor: 'Open in editor',
      newCategory: 'New Category',
      newCategoryDescription: 'Choose new category from the list',
      addNewX: 'Add new {0}',
      import: 'Import',
      matchTransaction: 'Match transaction',
      export: 'Export',
      enable: 'Enable',
      disable: 'Disable',
      edit: 'Edit',
      copyValue: 'Copy Value',
      filterOnValue: 'Filter on Value',
      filterOnUser: 'Filter on User',
      priority: 'Priority',
      approval: 'Approval',
      updatedBy: 'Updated By',
      lastUpdatedAt: 'Last Updated At',
      stringFilterExample: 'String Filter Example',
      save: 'Save',
      search: 'Search',
      areYouSureDeleteRuleset: 'Are you sure you want to delete this ruleset?',
      theRuleset: 'The Ruleset',
      thisRuleset: 'This Ruleset',
      thisRulesetVersion: 'This Ruleset Version',
      youWillAlsoSaveTheCurrentChanges: 'You will also save the current changes.',
      withSaveChanges: 'With save changes',
      youCanLoseUnsavedChanges: 'You can lose your unsaved changes.',
      statusCode: 'Status Code',
      percentage: 'Percentage',
      userDetails: 'User details',
      female: 'Female',
      male: 'Male',
      unknown: 'Unknown',
      deposit: 'Deposit',
      withdrawal: 'Withdrawal',
      theSelectedRuleset: 'The selected ruleset',
      applyHistoryChanges: 'Apply history changes',
      editor: 'Editor',
      allRulesets: 'All rulesets',
      allTemplates: 'All templates',
      xRulesets: '{0} rulesets',
      xTemplates: '{0} templates',
      templates: 'Templates',
      simulatePayment: 'Simulate payment',
      transactionMatching: 'Transaction matching',
      invalidTransactions: 'Invalid Transactions',
      defaultTemplates: 'Default templates',
      merchantSavedTemplates: 'Merchant saved templates',
      pendingApproval: 'Pending Approval',
      pending: 'Pending',
      noRulesMatched: 'No rules matched.',
      noOptions: 'No options.',
      ruleCategory: 'Rule Category',
      rulesetId: 'Ruleset ID',
      ruleId: 'Rule ID',
      reorderRules: 'Reorder rules',
      configureAtLeastOneXToBeAbleToSave: 'Configure at least one {0} rule to be able to save this ruleset',
      copiedToClipboard: 'Copied to clipboard',
      beta: 'BETA',
      close: 'Close',
    },
    genericsDetails: {
      primFin: 'The main point of contact for financial matters.',
      secFin: `Assist the primary financial contact in managing 
      financial matters, and serve as a backup point of contact when necessary.`,
      primCom: 'Managing the business and commercial relationship and agreements.',
      primOp: `The main point of contact for operational matters within an organization 
      or project, and to oversee the day-to-day operations to ensure they run smoothly and efficiently.`,
      secOp: `Support the Primary Operational contact in managing operational matters, and serve as 
      a backup point of contact when necessary to ensure continuity in the operations.`,
      primSup: `Provide assistance and support to end-users, and ensure that their 
      needs and inquiries are addressed promptly and effectively.`,
      stayUpdated: 'You can update your data at any time from the Admin/Backoffice users page.',
      backofficeHomepage:
        'Choose what page you would like to see first when you visit PaymentIQ Backoffice. Changes apply after refresh.',
      sidebar: 'Select whether you would like to have the sidebar open or collapsed on desktop devices.',
      aiChatbot: 'By default shows a chatbot helper button in the bottom right corner of the screen.',
      restoreLayout: 'Restore the Home Page Widgets to the default layout',
      uploadNewLogo:
        'Upload overrides previously uploaded logo for the selected merchant ID and locale. The page will refresh for an optimal experience.',
      noNotifications: 'No alerts to display at the moment',
      configAlertsHere: 'Configure Alerts Here',
    },
    inputs: {
      errors: {
        required: 'This field is required',
        mustBeNumber: 'Must be a number',
        tooShort: 'Too short',
        tooLong: 'Too long',
        mobileNumber: 'Mobile number can start with + symbol and must contain only digits.',
        invalidEmail: 'Invalid email',
      },
    },
    pages: {
      home: {
        title: 'Home',
      },
      transactions: {
        title: 'Transactions',
        pageNotice:
          'This is the new version of the Transactions view. In case of issues, click here to use the old one.',
      },
      approve: {
        title: 'Approve',
        searchTransactions: 'Search transactions',
        viewTransaction: 'View transaction',
        viewUserDetails: 'View user details',
        exportTransactionsTitle: 'Export Transactions',
        exportTransactionsMessage: 'Choose the file type you want to export the transactions to:',
        withdrawalApprovedLabel: 'Withdrawal approved',
        commentLabel: 'Comment',
        delayApproval: 'Delay approval',
        delayApprovalNote:
          'This functionality will trigger a re-evaluation of Approval rules. This re-evaluation can benefit from the reason tag, which is added to the Info. Hence, you can enhance the approval rules by adding Info condition with a regex such as: .*DA-1.*',
        deny: 'Deny',
        denyReasons: {
          depositNotWagered: 'Deposit Not Wagered',
          wrongWithdrawalMethod: 'Wrong Withdrawal Method',
        },
        hold: 'Hold',
        holdReasons: {
          reasonOne: 'Reason 1',
        },
        unhold: 'Unhold',
        approve: 'Approve',
        approveAllFailed: 'Failed to approve all transactions',
        approveSomeFailed: 'Failed to approve transactions: {0}',
        approveSomeSucceeded: 'Transactions approved successfully: {0}.',
        approveSuccess: 'Transactions approved successfully',
        approveError: 'Failed to approve transactions',
        delayApprovalAllFailed: 'Failed to delay approval for all transactions',
        delayApprovalSomeFailed: 'Failed to delay approval for transactions: {0}',
        delayApprovalSomeSucceeded: 'Transactions delayed successfully: {0}.',
        delayApprovalSuccess: 'Transactions delayed successfully',
        delayApprovalError: 'Failed to delay approval for transactions',
        holdAllFailed: 'Failed to hold all transactions',
        holdSomeFailed: 'Failed to hold transactions: {0}',
        holdSomeSucceeded: 'Transactions held successfully: {0}.',
        holdSuccess: 'Transactions held successfully',
        holdError: 'Failed to hold transactions',
        denyAllFailed: 'Failed to deny all transactions',
        denySomeFailed: 'Failed to deny transactions: {0}',
        denySomeSucceeded: 'Transactions denied successfully: {0}.',
        denySuccess: 'Transactions denied successfully',
        denyError: 'Failed to deny transactions',
        unholdAllFailed: 'Failed to unhold all transactions',
        unholdSomeFailed: 'Failed to unhold transactions: {0}',
        unholdSomeSucceeded: 'Transactions unheld successfully: {0}.',
        unholdSuccess: 'Transactions unheld successfully',
        unholdError: 'Failed to unhold transactions',
      },
      userAccounts: {
        title: 'User Accounts',
      },
      kyc: {
        title: 'KYC',
      },
      search: {
        title: 'Search',
      },
      block: {
        title: 'Block',
      },
      routing: {
        title: 'Routing',
      },
      fallback: {
        title: 'Fallback',
      },
      tools: {
        title: 'Tools',
      },
      store: {
        title: 'Store',
      },
      product: {
        title: 'Product',
      },
      voucher: {
        title: 'Voucher',
      },
      finance: {
        title: 'Finance',
      },
      settlements: {
        title: 'Settlements',
      },
      balance: {
        title: 'Balance',
      },
      analytics: {
        title: 'Analytics',
        pageNoticeTitle:
          'We are migrating the Analytics engine from Elasticsearch to OpenSearch. The migration is scheduled for February 25. Core features will remain the same, but the user interface will look different. Please use only the OS Analytics page for making any changes, or changes will be lost after migration. Report any issues to the Customer Experience Center. Click here for more information.',
        pageNoticeContent1:
          'We are migrating the Analytics engine from Elasticsearch to OpenSearch. The migration is scheduled for February 25. Core capabilities remain the same, but the user interface will look different.',
        pageNoticeContent2:
          'During the BETA rollout, you will have access to both the existing Analytics page and the new OS Analytics page. If you encounter issues, you can revert to the old Analytics page, but any updates must be done on the OS Analytics page. Report any issues to our Customer Experience Center.',
        pageNoticeContent3:
          'At the time of the migration on February 25, the OS Analytics page will be renamed to Analytics, and the existing Analytics page will be removed. The new Analytics page will be the single entry point for analytics with the new OpenSearch backend.',
        pageNoticeContent4:
          'As you experience the transition, please use only the OS Analytics page for making any changes, or changes will be lost after migration, and report any issues to our Customer Experience Center.',
      },
      analyticsDefault: {
        title: 'Default',
      },
      analyticsMerchant: {
        title: 'Merchant',
      },
      analyticsPrivate: {
        title: 'Private',
      },
      rules: {
        title: 'Rules',
        desc: 'Adjust the fee for credit cards or set the limit.',
      },
      rulesetsWorkflow: {
        title: 'Rules Hub',
        newRuleset: 'New ruleset',
        newRulesetCC: 'New Ruleset',
        matchTransactionModalInfo:
          'Once you press the match button, the all ruleset table will be updated based on your input.',
        priorityChangeApprovalNeedToBeResolvedFirst:
          'The priority change approval need to be resolved first, before applying any other actions.',
        matchedResult: 'Matched result',
        areYouSureEditRulesetLoseChanges:
          'Are you sure you want to edit a new ruleset? All unsaved changes will be lost.',
      },
      rulesetsWorkflowAllRulesets: {
        title: 'Overview',
        desc: 'Manage your ruleset builder creations in one place. You can perform individual ruleset actions, bulk actions or general actions.',
        matchTransactionsAgainstRules: 'Match transactions against rules',
        pendingApprovalRulesetWarningMessage:
          'There are selected rulesets that have an active pending approval, these will be ignored.',
      },
      rulesetsWorkflowSimulator: {
        title: 'Simulator',
        transactionIDsInfo: 'Valid transactions have the Payment Method: DEPOSIT or WITHDRAWAL',
        showGlobal: 'Show global',
        showBuilderView: 'Show builder view',
        transactionXMatchedWithAGlobalRule:
          'Transaction {0}was matched with some of the global rules. To investigate the details of this rule configurations look up:',
        noPreviewForGlobalRules: 'No preview is supported for the rules configured in PIQ global backoffice.',
      },
      rulesetsWorkflowPerformance: {
        title: 'Performance',
        desc: 'Compare and analyze ruleset performance on the Performance Page to access error and success metrics, optimizing your transaction flows.',
        filterStatusCode: 'Filter status code',
        selectARulesetDescription:
          'Please select a ruleset to analyse the performance of the selected ruleset.',
      },
      rulesetsWorkflowRulesetBuilder: {
        title: 'Builder',
        addDescriptionNote: 'Add description note for this rule...',
        emptyMainNodeDescription: "It's mandatory to add name for the ruleset to be able to proceed",
        xOfTheRuleset: '{0} of the ruleset',
        areYouSureSaveRulesetAsTemplate: 'Are you sure you want to save this ruleset as template?',
        areYouSureDeleteTheTemplate: 'Are you sure you want to delete the template?',
        areYouSureApplyTheTemplateLoseChange:
          'Are you sure you want to apply a template? All unsaved changes will be lost.',
        itsMandatoryToAddInfoToCategory: "It's mandatory to add information to the {0} category",
        rulesetConfiguration: 'Ruleset configuration',
        rulesetConfigurationDescriptionX: 'Configure {0} rules',
        noConditionsConfigured: 'No conditions configured',
        noActionsConfigured: 'No actions configured',
        configurePreconditions: 'Configure Preconditions for the ruleset',
        configureNameAndNote: 'Configure the name and note for the ruleset',
      },
      xRouting: {
        title: '{0} Routing',
      },
      xFallback: {
        title: '{0} Fallback',
      },
      fraudProvider: {
        title: 'Fraud Provider',
      },
      fees: {
        title: 'Fees',
      },
      fee: {
        title: 'Fee',
      },
      providerFee: {
        title: 'Provider Fee',
      },
      limit: {
        title: 'Limit',
      },
      fraudBlocks: {
        title: 'Fraud Blocks',
      },
      xBlock: {
        title: '{0} Block',
      },
      velocity: {
        title: 'Velocity',
      },
      userPspAccount: {
        title: 'User PSP Account',
      },
      forex: {
        title: 'Forex',
      },
      statusCode: {
        title: 'Status Code',
      },
      paymentMethods: {
        title: 'Payment Methods',
      },
      inputs: {
        title: 'Inputs',
      },
      logos: {
        title: 'Logos',
      },
      alerts: {
        title: 'Alerts',
      },
      notification: {
        title: 'Notification',
      },
      approval: {
        title: 'Approval',
      },
      vat: {
        title: 'VAT',
      },
      voidCapture: {
        title: 'Void/Capture',
      },
      admin: {
        title: 'Admin',
      },
      schemeTokenOnboarding: {
        title: 'Scheme Token Onboarding',
      },
      backofficeUsers: {
        title: 'Backoffice Users',
      },
      auditLog: {
        title: 'Audit Log',
        columnsHeader: {
          id: 'ID',
          level: 'Level',
          source: 'Source',
          sourceInstance: 'Instance',
          created: 'Created',
          tags: 'Tags',
          merchantId: 'Merchant ID',
          username: 'User',
          userId: 'User ID',
          sessionId: 'Session ID',
          targetMerchantId: 'Target merchant ID',
          ipAddress: 'IP Address',
          clientId: 'Client ID',
          realmId: 'Realm ID',
          httpMethod: 'HTTP method',
          executionTimeMs: 'Exec time (ms)',
          responseCode: 'Response code',
          uri: 'URI',
        },
      },
      configuration: {
        title: 'Configuration',
      },
      cashier: {
        title: 'Cashier',
      },
      merchant: {
        title: 'Merchant',
      },
      maintenance: {
        title: 'Maintenance',
      },
      apiClients: {
        title: 'API Clients',
      },
      invoice: {
        title: 'Invoice',
      },
      customer: {
        title: 'Customer',
      },
      templates: {
        title: 'Templates',
      },
      emailTemplates: {
        title: 'Email',
      },
      scriptTemplates: {
        title: 'Script',
      },
      htmlTemplates: {
        title: 'HTML',
      },
      sqlTemplates: {
        title: 'SQL',
      },
      mqTemplates: {
        title: 'MQ',
      },
      cssTemplates: {
        title: 'CSS',
      },
      messages: {
        title: 'Messages',
      },
      forexRates: {
        title: 'Forex Rates',
      },
      iin: {
        title: 'IIN',
        messages: {
          updateError: 'Failed to update entity, please try again later',
          updateSuccess: 'Successfully updated entity',
        },
      },
      investigate: {
        title: 'Investigate',
        fields: {
          keyword: 'Keyword',
          status: 'Status',
          tag: 'Tag',
          user: 'User',
          doTransferOrCancel: 'Do transfer or cancel',
          initiatedPsp: 'Init PSP',
          rules: 'Rules',
          ipCity: 'IP City',
          ipCountry: 'IP Country',
          ipRegion: 'IP Region',
          initiatedPspAccount: 'Init PSP Account',
          merchants: 'Merchants',
          onlyFirstDepositors: 'Only first depositors',
          type: 'Type',
          notificationDate: 'Notification Date',
          paymentMethod: 'Payment Method',
          initialPsps: 'Initial PSPs',
          psps: 'PSPs',
          channel: 'Channel',
          userCountry: 'User country',
          txRefId: 'Transaction Reference ID',
          currency: 'Currency',
          minAmount: 'Min. amount',
          maxAmount: 'Max. amount',
          startDate: 'Start date',
          endDate: 'End date',
          pspStatus: 'PSP status',
          pspStatusMsg: 'PSP Status Message',
          maskedAccount: 'Masked account',
          info: 'Info',
          cardBin: 'Card bin',
          cardIssuerBrand: 'Card issuer brand',
          cardIssuerCategory: 'Card issuer category',
          cardIssuerType: 'Card issuer type',
          cardIssuerName: 'Card issuer name',
          cardIssuerCountry: 'Card issuer country',
          created: 'Created',
          id: 'Transaction ID',
          merchantId: 'Merchant ID',
          merchantUserId: 'User',
          merchantUserEmail: 'User Email',
          kycStatus: 'KYC Status',
          kycPspName: 'KYC PSP Name',
          kycPspStatus: 'KYC PSP Status',
          kycPspIdStatus: 'KYC ID Status',
          kycPspAddressStatus: 'KYC Address Status',
          kycPspLivenessStatus: 'KYC PSP liveness status',
          kycPspAgeStatus: 'KYC Age Status',
          kycPspPepAndSanction: 'KYC PEP and Sanction',
          suspectedAbuseReason: 'Abuse',
          blockedAccountReason: 'Blocked',
          txAmount: 'Transaction Amount',
          txType: 'Transaction Type',
          authAmount: 'Auth Amount',
          merchantUserBal: 'User Balance',
          state: 'State',
          ipAddr: 'User IP',
          statusCodeInt: 'Status Code',
          statusCode: 'Status Description',
          pspStatusCode: 'PSP Status Code',
          psp: 'PSP',
          pspAccount: 'PSP Account',
          pspService: 'PSP Service',
          amount: 'Amount',
          fee: 'Fee',
          lastUpdated: 'Updated',
          updatedBy: 'Last Updated By',
          channelId: 'Channel ID',
          merchantUserCat: 'User Category',
          userCat: 'User category',
          merchantUserCountry: 'User Country',
          maskedUserAccount: 'User account',
          bankName: 'Bank Name',
          accountHolderName: 'Account Holder',
          firstName: 'First Name',
          lastName: 'Last Name',
          merchantUserStreet: 'Street',
          merchantUserCity: 'City',
          merchantUserZip: 'ZIP',
          merchantUserDOB: 'DOB',
          merchantUserMobile: 'Mobile',
          issuerCountry: 'Issuer country',
          issuerInfoBrand: 'Issuer brand',
          issuerInfoCategory: 'Issuer category',
          issuerInfoName: 'Issuer name',
          issuerInfoNumber: 'IIN',
          issuerInfoType: 'Card Type',
          pspUserRef: 'PSP User Reference',
          pspFraudScore: 'PSP Fraud Score',
          fraudProviderStatus: 'Fraud Status',
          pspRefId: 'PSP Reference ID',
          merchantTxId: 'Site Reference ID',
          bonusCode: 'Bonus Code',
          firstAttempt: 'First Attempt',
          firstSuccessful: 'First Successful',
          firstTxTypeAttempt: 'First Transaction Type Attempt',
          firstTxTypeSuccessful: 'First Transaction Type Successful',
          firstUserPspAccountAttempt: 'First PSP Account Attempt',
          firstUserPspAccountSuccessful: 'First PSP Account Successful',
          lastInfo: 'Last Info',
          originTxId: 'Origin Transaction ID',
          lastUpdatedFrom: 'Last updated from',
          lastUpdatedTo: 'Last updated to',
        },
        actions: {
          refund: 'Refund',
          viewUserDetails: 'View User Details',
          viewTxDetails: 'View Transaction Details',
          partialRefund: 'Partial Refund',
          capture: 'Capture',
          exportTransactions: 'Export Transactions',
          partialCapture: 'Partial Capture',
          manualVoid: 'Void',
          manualChargeBack: 'ChargebackWon',
          requestForInfo: 'RequestForInfo',
          notificationOfFraud: 'NotificationOfFraud',
          anonymizeUserForGDPR: 'Anonymize user (GDPR)',
          forceSuccessful: 'Force Successful',
          forceFailed: 'Force  Failed',
          forceInconsistent: 'Force Inconsistent',
          forceStatus: 'Force Status',
          extendedAuth: 'Extended Auth',
          registerCorrection: 'Register Correction',
        },
        messages: {
          updateError: 'Failed to update entity, please try again later',
          updateSuccess: 'Successfully updated entity',
          anonymizationSuccess: 'User anonymization succeeded',
          voidSuccess: 'Selected items have been marked void',
          forceStatusSuccess: 'Status successfully changed',
          refundSuccess: 'Refund successfully placed',
          captureSuccess: 'Capture successfully placed',
          extendAuthSuccess: 'Extend auth action successfully done',
          anonymizationFailure: 'The following users still have transactions under process',
          sureToAnonymize: 'Are you sure you want to anonymize this user?',
          anonymizeNotice:
            'By approving this action, all information related to this user will anonymized (PTX, KYC, and User PSP accounts)!',
          statusChangeNotice: 'Are you sure you want to update the selected transactions as ',
          voidNotice: 'Are you sure you want to void the selected transactions?',
        },
        correctionTypes: {
          Refund: 'Manual Refund',
          PartialRefund: 'Manual Partial Refund',
          Capture: 'Capture',
          PartialCapture: 'Partial Capture',
          Void: 'Manual Void',
          ManualChargeBackWon: 'Manual ChargebackWon',
          ManualRequestForInfo: 'Manual RequestForInfo',
          ManualNotificationOfFraud: 'Manual NotificationOfFraud',
          ManualChargeback: 'Manual Chargeback',
        },
        txDetails: {
          originAuth: 'Origin Auth',
          totalCapture: 'Total Captured',
          remaining: 'Remaining',
          captureAmount: 'Capture Amount',
          remainingAuth: 'Remaining Auth',
          originTx: 'Origin Tx',
          refundAmount: 'Refund Amount',
          debitUser: 'Debit User',
          totalRefunded: 'Total Refunded',
        },
      },
      bankMapping: {
        title: 'Bank Mapping',
      },
      credentialsTemplate: {
        title: 'Credentials Template',
      },
      documentation: {
        title: 'Documentation',
      },
      aiq: {
        title: 'AccountIQ',
      },
      settings: {
        title: 'Settings',
      },
      myAccount: {
        title: 'My account',
      },
      error: {
        title: 'Error',
        pageHeader: 'Page not found',
        pageMessage: 'Page {0} not found.',
      },
      osAnalytics: {
        title: 'OS Analytics',
      },
    },
    components: {
      export: {
        shouldExportTableResults: 'Only export the results in the current table',
      },
      inkeep: {
        canDrag: 'Drag the button to change its place',
        supportLabel: 'Learn About Our AI Chatbot',
      },
      generalHealth: {
        amountDesc: 'The sum of successful deposit transactions within the given period',
        atvDesc:
          'The sum of successful deposit transactions divided by the number of successful transactions within the given period',
        accRateDesc:
          'The number of successful transactions divided by the number of transactions within the given period',
        successDesc: 'The number of successful deposit transactions within the given period',
        totalDesc:
          'The number of successful, failed, and cancelled deposit transactions within the given period',
      },
      xmlConfiguration: {
        updateConfigFailure: 'Failed to update the configuration, please try again later',
        updateConfigSuccess: 'Successfully updated the configuration',
        deleteConfigFailure: 'Failed to delete the configuration, please try again later',
        changeNotes: 'Please write a note about the changes that were done.',
        templateConfig: 'Template Configuration',
      },
      homepageWidgets: {
        latestBlogs: 'Latest Blogs',
      },
      rules: {
        targetedRules: 'Targeted Rules',
        match: 'Match transaction against rules',
        matchedIds: 'Found {0}, opening first matched ruleset.',
        newId: "Generate new rule ID's",
        newIdSuccess: 'New IDs generated successfully.',
        newIdNone: 'No IDs to generate.',
        importSuccess: 'Import successful',
        saveOrderTooltip: 'Updates the ruleset priority according to the order in the list.',
        saveOrderSuccess: 'Ruleset priority updated successfully.',
        clearMatched: 'Clear matched rules',
        writeNote: 'Please write a note about the changes that were done.',
      },
      filters: PAGE_FILTER_FIELDS_EN,
      transactionColumns: TRANSACTION_COLUMNS_EN,
    },
    statusCodeDesc: {
      ERR_SYSTEM_ERROR: 'This is a non-specific System Error. Contact PaymentIQ Support or your Tech Team',
      ERR_FAILED_TO_CONNECT:
        'The system could not connect to the PSP. It might be temporary or indicate a bigger problem. Contact PaymentIQ Support or your Tech Team.',
      ERR_DECLINED_BAD_REQUEST:
        'One of the payment parameters was not correct, and the transaction was refused. It is usually an integration issue. Contact PaymentIQ Support or your Tech Team.',
      ERR_DECLINED_FRAUD:
        'This usually indicates that the PSP has declined the transaction due to a fraud rule on their side or a Velocity Fraud check in PIQ.',
      ERR_DECLINED_NO_FUNDS:
        'This usually means the user does not have funds to complete the transaction. They need to use a different card or method.',
      ERR_DECLINED_ACCOUNT_SUSPENDED:
        "The user's payment account is not working, and they need to contact their payment institution.",
      ERR_DECLINED_OTHER_REASON:
        "This is a non-specific decline reason, but originates with the user's payment provider, not from an error. The user should contact their payment Institution.",
      ERR_DECLINED_CONTACT_SUPPORT:
        "This is a non-specific decline reason, but originates with the user's payment provider, not from an error. The user should contact their payment Institution.",
      ERR_DECLINED_CONFIG_ERROR:
        'Declined because of system config error, not because of user input error. This normally means that the provider cannot be used because one or more config parameters are invalid. Contact PaymentIQ Support.',
      ERR_NOT_AUTHENTICATED:
        'The user has not been properly authenticated. It could mean they used the wrong details when logging into their bank, eWallet, etc.',
      ERR_INVALID_RESPONSE: 'This is a system error. Please contact PaymentIQ Support or your Tech Team.',
      ERR_DECLINED_REQ_BLOCKED:
        "The transaction has been blocked. It might be from the PSP or by a rule in PaymentIQ. Have a look at the 'Info' column for more insight.",
      ERR_PSP_OUT_OF_SERVICE:
        'The PSP seems out of service, and did not respond to the transaction request. If there are other transactions with the same error, you likely need to contact the PSP, but PaymentIQ support might also be able to help.',
      ERR_DECLINED_NOT_AUTHORIZED:
        "This is a non-specific decline reason, but originates with the user's payment provider, not from an error.",
      ERR_RESPONSE_CODE_UNKNOWN:
        "The PSP gave an unknown response. Have a look at the 'Info' column for more insight.",
      ERR_PSP_ACCOUNT_USED_BY_OTHER_USER: 'The user payment method is already used by someone else.',
      ERR_PSP_ACCOUNT_NOT_USED:
        'The user is restricted from withdrawing because they have not used this method to deposit. Your PIQ admin can circumvent this by adding a specific rule in Rules > Fraud Blocks > User PSP Account, or the user should use a different method.',
      ERR_TOO_MANY_PSP_ACCOUNTS:
        'The user has too many payment accounts, as defined in Rules > Fraud Blocks > User PSP Account. Ask your PaymentIQ admin what the maximum is.',
      ERR_DECLINED_DUPLICATE_TX_ID:
        'Usually means that a transaction was in progress when another similar transaction was started. Ask the user to try again, or contact PaymentIQ Support.',
      ERR_DECLINED_INVALID_ACCOUNT_NUMBER:
        'Usually means that the card number or other payment account number was invalid. The user should check their details and try again.',
      ERR_MERCHANT_OUT_OF_SERVICE:
        'The merchant (you) is not responding to the API call from PaymentIQ. The server is offline., Contact your Tech Team.',
      ERR_DECLINED_LIMIT_OVERDRAWN:
        "Can mean that the user's payment method has a limit which they exceeded. It is on the user payment method side, and the user should contact their bank, or use a different method.",
      ERR_MERCHANT_RESPONSE_CODE_UNKNOWN:
        'The merchant (you) server is not responding correctly. Contact your Tech team to resolve it.',
      ERR_DECLINED_NO_PROVIDER_FOUND:
        'PaymentIQ could not route the payment to a PSP. Check your routing rules.',
      ERR_DECLINED_PROVIDER_ACCOUNT_CONFIG_ERROR:
        'PaymentIQ could not route to a PSP account. Check your routing rules or PSP configuration',
      ERR_MERCHANT_INVALID_RESPONSE:
        'The merchant (you) is responding to the API call from PaymentIQ strangely. Contact your Tech Team.',
      ERR_ABOVE_LIMIT:
        'This is triggered when the transaction amount is above the Limits set in PIQ Rules > Limits. Contact your PaymentIQ admin for details.',
      ERR_BAD_REQUEST:
        'This happens when the payment request has some invalid parameters, usually in the integration phase. Contact PaymentIQ Support or your Tech Team.',
      ERR_BELOW_LIMIT:
        'This is triggered when the transaction amount is below the Limits set in PIQ Rules > Limits. Contact your PaymentIQ admin for details.',
      ERR_DECLINED_3D_AUTHENTICATION_FAILED:
        'The user was unable to verify themselves using 3D secure. They will probably have to contact their bank to troubleshoot it.',
      ERR_DECLINED_BANK_REFUSAL:
        "The user's bank declined the transaction, and this originates with the user's payment provider, not from an error.",
      ERR_DECLINED_CARD_EXPIRED:
        'The card being used has expired. This is usually when a saved card has gone out of date. The user will have to re-enter their card details.',
      ERR_DECLINED_CVV_FAIL:
        'The user entered the wrong CVV. They need to check their details and try again.',
      ERR_DECLINED_EMAIL_BLACKLIST:
        'This usually indicates that the PSP has declined the transaction due to a fraud rule on their side. Contact the PSP about it.',
      ERR_DECLINED_FRAUD_RULE_PSP:
        'This usually indicates that the PSP has declined the transaction due to a fraud rule on their side. Contact the PSP about it.',
      ERR_DECLINED_INVALID_AMOUNT:
        'The amount sent to the PSP is invalid. This usually happens with PSPs where the user can define or edit the amount during the transaction. It could also possibly be an error in the integration. Contact your Tech team or PaymentIQ Support.',
      ERR_DECLINED_INVALID_ISSUER:
        'The card issuer is not supported. It might be an AMEX, JCB, Union Pay, Dankort card, or maybe from a sanctioned country, like Iran.',
      ERR_DECLINED_ISSUER_UNAVAILABLE:
        "The transaction could not be processed as the user's bank who issued the card is offline and not responding.",
      ERR_DECLINED_LOST_OR_STOLEN:
        'The card has been registered as lost or stolen, and the card issuer has blocked it. It is usually a red flag for fraud or further investigation of the user account.',
      ERR_DECLINED_RESTRICTED_CARD:
        'This card can not make this type of transaction, the user bank refused it. They will need to use a different card or payment method.',
      ERR_DECLINED_RESTRICTED_TERRITORY:
        "The user's location is blocking the transaction on the PSP side. They will need to use a different method.",
      ERR_DECLINED_VELOCITY_RULE_PSP:
        'Usually indicates that the PSP has declined the transaction due to a velocity rule on their side, like Max transactions/day, etc. Contact the PSP about it.',
      ERR_INVALID_PARAMETER:
        'One of the parameters sent in the transaction is invalid or missing. Usually happens during integration and will need solving by your Tech Team or PaymentIQ Support.',
      ERR_IO_EXCEPTION:
        'There was a temporary connection issue. The user should try again, or if there are a lot of transactions like this, it is an issue, contact your Tech Team or PaymentIQ Support.',
      ERR_RESPONSIBLE_GAMING_LIMIT: 'The user hit their responsible gaming limits. Advise them accordingly.',
      ERR_USER_ACCOUNT_BLOCKED:
        'The user account is blocked on the PSP side. Ask the user to contact their payment institution to resolve it.',
      ERR_USER_SESSION_INVALID:
        'The verifyUser API call to the merchant was not verified. Usually happens in the integration phase, but otherwise ask the user to log out and back in again.',
      ERR_DECLINED_3D_VALIDATION_FAILED:
        "The 3D secure server used for the user's card did not validate the transaction. Usually a temporary issue and the cardholder should try again.",
      ERR_DECLINED_3D_EXPIRED:
        'The user did not verify their 3D secure password within the time allowed. They should try again.',
      ERR_VAULTIQ_OUT_OF_SERVICE:
        'The vault where PaymentIQ stores card details is not responding. Contact PaymentIQ Support.',
      ERR_DECLINED_IP_BLOCKED:
        'The transaction hit an IP blocking rule. This might be at the PSP or in Rules > Fraud Blocks > IP Blocks. Contact the PSP or your PIQ admin.',
      ERR_DECLINED_BIN_BLOCKED:
        'The transaction hit a BIN blocking rule. This might be at the PSP or in Rules > Fraud Blocks > BIN Blocks. Contact the PSP or your PIQ admin.',
      ERR_VAULTIQ_UNKNOWN_ACCOUNT:
        'The PaymentIQ card storage vault did not find the stored card. You should contact PaymentIQ Support.',
      ERR_DECLINED_KYC_BLOCK:
        'The transaction was declined due to a Rule in KYC > Block. Contact your PaymentIQ admin for clarification.',
      ERR_DECLINED_KYC_USER_UNDER_AGE:
        'The user was defined as underage for your service. Contact your PaymentIQ admin for clarification.',
      ERR_DECLINED_KYC_CHECK_FAILED:
        'The automated KYC check failed. It is either because the KYC service is offline, or not responding. Contact PaymentIQ Support.',
      ERR_DECLINED_BIC_BLOCK:
        'The bank transaction is blocked because of the BIC/SWIFT code. It is because of a rule in Rules > Fraud Blocks > BIC Blocks. Contact your PIQ admin.',
      ERR_DECLINED_EXPIRED: 'The transaction expired without the user completing it.',
      ERR_DECLINED_REPEAT_CANCELLED:
        'This is a duplicate transaction and has been declined. Ask the user to try again.',
      ERR_DECLINED_CURRENCY_NOT_SUPPORTED:
        'This usually means that the PSP is not supporting the currency of the user. The PIQ admin can solve it by adding a Forex rule to swap currencies before processing, or ask the PSP to activate the currency.',
      ERR_DECLINED_FRAUD_SCORE_THRESHOLD_EXCEEDED:
        'There was a fraud score that blocked the transaction. It is due to a rule in Rules > FraudBlock > FraudProviderBlock. Ask your PIQ admin for clarification.',
      ERR_DECLINED_MERCHANT_NOT_FOUND:
        'The PSP did not find the merchant account. Usually in the integration phase. Check the details in the PSP configuration in PIQ, or check with the PSP for the correct details.',
      ERR_DECLINED_MERCHANT_NOT_ENABLED:
        'The PSP recognizes the merchant but has not activated them yet. Contact the PSP and request activation.',
      ERR_DECLINED_PROVIDER_NOT_ENABLED:
        'The PSP is not enabled. It probably needs adding to the PIQ config, contact PaymentIQ support.',
      ERR_DECLINED_UNDER_MAINTENANCE:
        "This usually happens when the user's bank is under maintenance. This should be temporary, ask the user to try again.",
      ERR_NO_REFERRAL_TX_FOUND:
        'A transaction created in PIQ (like a refund/void/chargeback) cannot find the original transaction. Check your details, or maybe contact PaymentIQ Support.',
      ERR_DECLINE_TX_NOT_FOUND:
        'A transaction created in PIQ (like a refund/void/chargeback) cannot find the original transaction. Check your details, or maybe contact PaymentIQ Support.',
      ERR_DECLINE_COUNTRY_NOT_SUPPORTED:
        "The PSP indicates they do not support the user's country. Ask the user to move countries, or ask the PSP to add support for this country.",
      ERR_DECLINED_NOT_SUPPORTED_PAYMENT_METHOD_FRAUD:
        'The PSP has flagged this as a potentially fraudulent transaction and declined it. Contact the PSP for clarification.',
      ERR_DECLINED_FRAUD_PROVIDER_ACCOUNT_CONFIG_ERROR:
        'This transaction could not find the required fraud provider to make the necessary checks. Check the fraud provider routing rules or the PIQ config.',
      ERR_DECLINED_GENERAL_BLOCK:
        'This is a general block, usually from a PaymentIQ rule. Contact your PIQ admin to see which rules are blocking the transaction.',
      ERR_READ_TIMEOUT:
        'The transaction timed out, but verify it in the PSP back office to see if it is completed.',
      ERR_REFERENCE_MISMATCH:
        'The transaction reference was an issue, you need to verify in the PSP back office to see if it was successful.',
      ERR_INCONSISTENT_TRANSACTION:
        'The transaction is inconsistent, e.g. funds may have been taken from the user, but not credited to their account. It needs to be manually investigated in the PSP back office.',
      ERR_UNKNOWN_CALLBACK:
        'The transaction is inconsistent, e.g. funds may have been taken from the user, but not credited to their account due to a communication error. It needs to be manually investigated in the PSP back office.',
      ERR_UNKNOWN_RESPONSE:
        'You need to investigate this one manually. Check the PSP back office to see if the customer transaction was completed.',
    },
    paymentProductCatalog: {
      psp: {
        sureToDelete: 'Are you sure you want to delete this PSP?',
        partialCapture: 'Partial Capture',
        partialRefund: 'Partial Refund',
        premiumPricing: 'Premium Pricing/Kickback',
        transactionFees: 'Transaction Fees',
        threeDSType: '3DS Type',
        threeDSTypeInternal: 'Internal',
        threeDSTypeExternal: 'External',
        threeDSTypeProviderManaged: 'Provider Managed',
      },
    },
  },
});

export default lang;
